'use strict';

import { Record, List } from 'immutable';

class Service extends Record({
  id: null,
  name: '',
  alias: ''
}) {

}

Service.make = function (serviceList) {
  if (!serviceList || !serviceList.size) {
    return new List();
  }

  const services = {
    1: {
      id: 1,
      name: 'Премиум',
      alias: 'premium'
    },
    2: {
      id: 2,
      name: 'Промо',
      alias: 'promo'
    }
  };

  return serviceList.map(v => new Service(services[v.get('id')]));
};

export default Service;



// WEBPACK FOOTER //
// ./src/classes/finance/service.js